import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ReactComponent as CrossButton } from "../assets/cross.svg";
import { Alert, Button, FormControl } from "@mui/material";
import {
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
} from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import InputBase from "@mui/material/InputBase";
import { useEffect, useState } from "react";
import GetUser from "../services/get-user";
import UserService from "../services/user-service";
import { toast } from "react-toastify";
import { ReactComponent as EditIcon } from "../assets/editpencil.svg";
import { ReactComponent as DeleteIcon } from "../assets/deleteIcon.svg";
import moment from "moment";

const useStyles = makeStyles({
  focused: {
    border: "1px solid rgb(206,212,218) !important",
  },
});

const GoalModal = ({
  open,
  setOpen,
  goalTitle,
  content,
  goalButtonList,
  addGoal,
  nrows,
  cardType,
}) => {
  const [incomeStream, setIncomeStream] = useState(0);
  const [bussinessGoal, setBussinessGoal] = useState("");
  const [bussinessGoalTime, setBussinessGoalTime] = useState("Day");
  const [oldBussinessGoal, setOldBussinessGoal] = useState("");
  const [oldBussinessGoalTime, setOldBussinessGoalTime] = useState("");
  const [remainGoal, setRemainGoal] = useState(0);
  const [deleteGoal, setDeleteGoal] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [editBussinessGoal,setEditBussinessGoal] = useState(false);
  const [isUpdateGoalValue, setIsUpdateGoalValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = GetUser();
  const classes = useStyles();

  useEffect(() => {
    UserService.getIncome().then((response) => {
      if (incomeStream !== 0) {
        if (cardType === "Revenue") {
          var data = response.data.saleGoalItem[incomeStream - 1];
          if(data === undefined) 
          {
            data=[];
            data.push(0,'none');
          }
          var goalType = editBussinessGoal ? bussinessGoalTime : data[1];
          if (editBussinessGoal) {
            setBussinessGoal(bussinessGoal);
            setBussinessGoalTime(bussinessGoalTime);
            setOldBussinessGoal(oldBussinessGoal);
            setOldBussinessGoalTime(oldBussinessGoalTime);
          } else {
            if (data !== undefined) {
              setBussinessGoal(data[0].toLocaleString());
              setBussinessGoalTime(data[1]);
              setOldBussinessGoal(data[0].toLocaleString());
              setOldBussinessGoalTime(data[1]);
             }
          }
          UserService.getSale().then((response) => {
            const salesData = response.data.sale.filter((item: any) => {
              return item.incomeStream == incomeStream;
            });

            switch (goalType) {
              case "day":
                const filterByDay = salesData
                  .filter(
                    (data: any) =>
                      moment(data.date).format("YYYY/MM/DD") ===
                      moment().format("YYYY/MM/DD")
                  )
                  .map((item: any) => {
                    return item.amount;
                  });
                const amountByDay = filterByDay.reduce(
                  (previousAmount, currentAmount, index) =>
                    previousAmount + currentAmount,
                  0
                );
                setRemainGoal(amountByDay);
                break;
              case "week":
                var weekNumber: any = [
                  moment().subtract(8,"days"),
                  moment().subtract(1,"days"),
                ];
                const filterByWeek = salesData
                  .filter((data: any) => {
                    return moment(data.date).isBetween(
                      weekNumber[0]._d,
                      weekNumber[1]._d
                    );
                  })
                  .map((item: any) => {
                    return item.amount;
                  });
                const amountByWeek = filterByWeek.reduce(
                  (previousAmount, currentAmount, index) =>
                    previousAmount + currentAmount,
                  0
                );
                setRemainGoal(amountByWeek);
                break;
              case "month":
                const filterByMonth = salesData
                  .filter(
                    (data: any) =>
                      new Date(data.date).getMonth() === new Date().getMonth()
                  )
                  .map((item: any) => {
                    return item.amount;
                  });
                const amountByMonth = filterByMonth.reduce(
                  (previousAmount, currentAmount, index) =>
                    previousAmount + currentAmount,
                  0
                );
                setRemainGoal(amountByMonth);
                break;
              case "year":
                const filterByYear = salesData
                  .filter(
                    (data: any) =>
                      new Date(data.date).getFullYear() ===
                      new Date().getFullYear()
                  )
                  .map((item: any) => {
                    return item.amount;
                  });
                const amountByYear = filterByYear.reduce(
                  (previousAmount, currentAmount, index) =>
                    previousAmount + currentAmount,
                  0
                );
                setRemainGoal(amountByYear);
                break;
              case "none":
                setRemainGoal(0);
                break;
            }
          });
        } else {
          var data = response.data.expenseCapItem[incomeStream - 1];
          if(data === undefined) 
          {
            data=[];
            data.push(0,'none');
          }
          var goalType = editBussinessGoal ? bussinessGoalTime : data[1];
          if (editBussinessGoal) {
            setBussinessGoal(bussinessGoal);
            setBussinessGoalTime(bussinessGoalTime);
            setOldBussinessGoal(oldBussinessGoal);
            setOldBussinessGoalTime(oldBussinessGoalTime);
          } else {
            if (data !== undefined) {
              setBussinessGoal(data[0].toLocaleString());
              setBussinessGoalTime(data[1]);
              setOldBussinessGoal(data[0].toLocaleString());
              setOldBussinessGoalTime(data[1]);
            }
          }
            UserService.getExpense().then((response) => {
              const expenseData = response.data.expense.filter((item) => {
                return item.incomeStream === incomeStream;
              });
              switch (goalType) {
                case "day":
                  const filterByDay = expenseData
                    .filter(
                      (data: any) =>
                        moment(data.date).format("YYYY/MM/DD") ===
                        moment().format("YYYY/MM/DD")
                    )
                    .map((item: any) => {
                      return item.amount;
                    });
                  const amountByDay = filterByDay.reduce(
                    (previousAmount, currentAmount, index) =>
                      previousAmount + currentAmount,
                    0
                  );
                  setRemainGoal(amountByDay);
                  break;
                case "week":
                  var weekNumber: any = [
                    moment().subtract(8, "days"),
                    moment().subtract(1, "days"),
                  ];
                  const filterByWeek = expenseData
                    .filter((data: any) => {
                      return moment(data.date).isBetween(
                        weekNumber[0]._d,
                        weekNumber[1]._d
                      );
                    })
                    .map((item: any) => {
                      return item.amount;
                    });
                  const amountByWeek = filterByWeek.reduce(
                    (previousAmount, currentAmount, index) =>
                      previousAmount + currentAmount,
                    0
                  );
                  setRemainGoal(amountByWeek);
                  break;
                case "month":
                  const filterByMonth = expenseData
                    .filter(
                      (data: any) =>
                        new Date(data.date).getMonth() === new Date().getMonth()
                    )
                    .map((item: any) => {
                      return item.amount;
                    });
                  const amountByMonth = filterByMonth.reduce(
                    (previousAmount, currentAmount, index) =>
                      previousAmount + currentAmount,
                    0
                  );
                  setRemainGoal(amountByMonth);
                  break;
                case "year":
                  const filterByYear = expenseData
                    .filter(
                      (data: any) =>
                        new Date(data.date).getFullYear() ===
                        new Date().getFullYear()
                    )
                    .map((item: any) => {
                      return item.amount;
                    });
                  const amountByYear = filterByYear.reduce(
                    (previousAmount, currentAmount, index) =>
                      previousAmount + currentAmount,
                    0
                  );
                  setRemainGoal(amountByYear);
                  break;
                case "none":
                  setRemainGoal(0);
                  break;
              }
            });
          }
        }
      }
    );
  }, [incomeStream, deleteGoal,open,isUpdateGoalValue]);

  useEffect(() => {
    if (nrows.length === 1) {
      setIncomeStream(1);
    }
  }, [nrows.length]);

  const handleSaveButton = () => {
    setLoading(true);
    if (incomeStream !== 0) {
      const businessGoalAmount = Number(bussinessGoal.split(",").join(""));
      try {
        cardType === "Revenue"
          ? UserService.addSalesGoal(
              user.userID,
              businessGoalAmount,
              bussinessGoalTime,
              incomeStream
            )
              .then((res) => {
                setLoading(false);
                setEditBussinessGoal(false);
                setOpen(false);
              })
              .catch((err) => setLoading(false))
          : UserService.addExpenseCap(
              user.userID,
              businessGoalAmount,
              bussinessGoalTime,
              incomeStream
            )
              .then((res) => {
                setLoading(false);
                setEditBussinessGoal(false);
                setOpen(false);
              })
              .catch((err) => setLoading(false));
      } catch (e: any) {
        setLoading(false);
      }
    } else {
      toast.error("please select business");
    }
  };

  const handleDeleteGoal = () => {
    try {
      cardType === "Revenue"
        ? UserService.addSalesGoal(user.userID, 0, "none", incomeStream)
            .then((res) => {
              setDeleteGoal(!deleteGoal);
              setOpen(false);
            })
            .catch((err) => console.log("err-->>>", err))
        : UserService.addExpenseCap(user.userID, 0, "", incomeStream)
            .then((res) => {
              setDeleteGoal(!deleteGoal);
              setOpen(false);
            })
            .catch((err) => console.log("err-->>>", err));
    } catch (e: any) {
      console.log("message---", e.message);
    }
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      height: "auto",
      fontWeight: "bolder",
      color: "#48b7a7",
      width: "18vw",
      padding: "10px 26px 10px 10px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));

  const progressWidth =
    (remainGoal * 100) / Number(bussinessGoal.split(",").join(""));

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="d-flex justify-content-center h-100 align-items-center">
        <Box className="goal-model">
          <Typography id="modal-modal-title" className="goal-title mb-4 mt-2">
            <div className="d-flex justify-content-between goal-modal-title">
              {goalTitle}
              <CrossButton
                className="goal-cross-icon"
                onClick={() => {
                  setOpen(false);
                  setEditBussinessGoal(false);
                }}
              />
            </div>
          </Typography>
          <div id="modal-modal-description">
            <FormControl variant="standard" className="goal-model-dropbox">
              <Select
                id="exp-source-option"
                value={incomeStream}
                onChange={(e: any) => {
                  setIncomeStream(e.target.value);
                }}
                input={<BootstrapInput className="bootstrapInput" />}
              >
                <MenuItem
                  className="source-dropdown"
                  key="all"
                  value={0}
                  disabled
                >
                  Select Business
                </MenuItem>
                {nrows.map((graph, index) => (
                  <MenuItem
                    className="source-dropdown"
                    key={index}
                    value={index + 1}
                  >
                    {graph}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {incomeStream !== 0 && (
            <>
              <div className="d-flex justify-content-between mb-2 mt-4">
                <div className="d-flex align-items-center goal-timeframe mt-3 ">
                  <p className="font-weight-bolder">
                    {bussinessGoalTime.charAt(0).toUpperCase() +
                      bussinessGoalTime.slice(1)}
                  </p>
                  <p className="ml-3 mt-0">${bussinessGoal.toLocaleString()}</p>
                </div>
              </div>

              <div>
                <div
                  className="progressBar"
                  onMouseEnter={() => setShowProgress(true)}
                  onMouseLeave={() => setShowProgress(false)}
                >
                  <div
                    className="progress"
                    style={{
                      maxWidth: "100%",
                      width: `${
                        parseInt(bussinessGoal) === 0 ? 0 : progressWidth
                      }%`,
                    }}
                  />
                  {parseInt(bussinessGoal) !== 0 && remainGoal !== 0 && (
                    <span
                      className="progressbar-label"
                      style={{
                        color: "#000000",
                        right: `${
                          parseInt(
                            (
                              (remainGoal * 100) /
                              parseInt(bussinessGoal)
                            ).toFixed(1)
                          ) > 12
                            ? remainGoal > parseInt(bussinessGoal)
                              ? 1
                              : `calc(100% - ${(
                                  (remainGoal * 100) /
                                  parseInt(bussinessGoal)
                                ).toFixed(1)}`
                            : 80
                        }%`,
                      }}
                    >
                      {showProgress
                        ? ` ${
                            parseInt(progressWidth.toFixed(1)) > 100
                              ? 100
                              : progressWidth.toFixed(1)
                          }% `
                        : `$${remainGoal.toLocaleString()}`}
                    </span>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <FormControl variant="standard">
                    <Select
                      id="exp-source-option"
                      value={bussinessGoalTime}
                      onChange={(e: any) => {
                        setBussinessGoalTime(e.target.value);
                        e.target.value != oldBussinessGoalTime
                          ? (() => {
                              setEditBussinessGoal(true);
                              setIsUpdateGoalValue(!isUpdateGoalValue);
                            })()
                          :(()=>{
                            setEditBussinessGoal(false);
                            setIsUpdateGoalValue(!isUpdateGoalValue);
                          })()
                      }}
                      style={{ width: 85 }}
                      input={
                        <BootstrapInput
                          className="bootstrapInput"
                          style={{ width: 85 }}
                        />
                      }
                    >
                      {goalButtonList.map((timeFrame, index) => (
                        <MenuItem
                          className="source-dropdown"
                          key={index}
                          value={String(timeFrame).toLowerCase()}
                        >
                          {timeFrame}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ m: 1, width: "80px" }} variant="outlined">
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      aria-describedby="outlined-weight-helper-text"
                      value={bussinessGoal.toLocaleString()}
                      onChange={(e) => {
                        setBussinessGoal(
                          Number(
                            e.target.value.replace(/\D/g, "")
                          ).toLocaleString()
                        );
                        Number(
                          e.target.value.replace(/\D/g, "")
                        ).toLocaleString() !=
                          oldBussinessGoal.toLocaleString() ||
                        bussinessGoalTime != oldBussinessGoalTime
                          ? (()=>{
                            setEditBussinessGoal(true);
                            setIsUpdateGoalValue(!isUpdateGoalValue)
                          })()
                          : (()=>{setEditBussinessGoal(false);
                            setIsUpdateGoalValue(!isUpdateGoalValue)
                          })()
                      }}
                      style={{ padding: "4px 3px" }}
                      classes={{ notchedOutline: classes.focused }}
                    />
                  </FormControl>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <DeleteIcon className="mt-2" onClick={handleDeleteGoal} />
                </div>
              </div>
              <Button
                className={`goal-save-button ${
                  editBussinessGoal ? ` enable` : `disable`
                }`}
                onClick={handleSaveButton}
              >
                {loading ? (
                  <>
                    <CircularProgress className="file-loader mr-3" /> Updated{" "}
                  </>
                ) : (
                  "Save"
                )}
              </Button>
            </>
          )}
          {remainGoal >= Number(bussinessGoal.split(",").join("")) &&
            Number(bussinessGoal.split(",").join("")) !== 0 &&
            (cardType === "Revenue" ? (
              <Alert severity="success" className="p-1 goal-success-alert ">
                Congratulations! You reached your goal for the{" "}
                {bussinessGoalTime}!
              </Alert>
            ) : (
              <Alert severity="error" className="p-1 goal-error-alert ">
                Uh oh! You have exceeded your expense cap for the{" "}
                {bussinessGoalTime}.
              </Alert>
            ))}
        </Box>
      </div>
    </Modal>
  );
};

export default GoalModal;
